/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharereviewapprove2Inputs */

const en_sharereviewapprove2 = /** @type {(inputs: Sharereviewapprove2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approve`)
};

const de_sharereviewapprove2 = /** @type {(inputs: Sharereviewapprove2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freigeben`)
};

/**
* | output |
* | --- |
* | "Approve" |
*
* @param {Sharereviewapprove2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharereviewapprove2 = /** @type {((inputs?: Sharereviewapprove2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharereviewapprove2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharereviewapprove2(inputs)
	return de_sharereviewapprove2(inputs)
});
export { sharereviewapprove2 as "shareReviewApprove" }